export default __webpack_public_path__ + "static/media/emoji_cal.06f83169.svg";